import { render, staticRenderFns } from "./SettingCreateEdit.vue?vue&type=template&id=15fcf7b1&scoped=true"
import script from "./SettingCreateEdit.vue?vue&type=script&lang=js"
export * from "./SettingCreateEdit.vue?vue&type=script&lang=js"
import style0 from "./SettingCreateEdit.vue?vue&type=style&index=0&id=15fcf7b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fcf7b1",
  null
  
)

export default component.exports